/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import XcoverSVG from '@toucan/client/global/images/brands/powered-by-xcover.svg';

import { MarketContext } from '@toucan/client/global/market';

import { LinkTarget } from '@toucan/client/shared/components/link';

import { XCoverLinkProps, XCoverLinkSkeletonProps } from './types';
import { styles } from './x-cover-link.styles';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'x-cover__link';

export const StyledXCoverLink = styled.div`
    ${styles}
`;

export const XCoverLinkSkeleton = ({
    'data-testid': dataTestid = DEFAULT_TEST_ID,
    className: className = 'x-cover-link-skeleton',
}: XCoverLinkSkeletonProps) => {
    return (
        <StyledXCoverLink className={className}>
            <Skeleton variant={SkeletonVariant.TEXT} data-testid={dataTestid} />
        </StyledXCoverLink>
    );
};

export const XCoverLink: FunctionComponent<XCoverLinkProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
}) => {
    const { activeMarket } = useContext(MarketContext);

    return (
        <StyledXCoverLink>
            <a
                href={`https://www.xcover.com/${activeMarket.language}/about`}
                target={LinkTarget.BLANK}
                data-testid={dataTestId}
            >
                <XcoverSVG className="xcover-logo" />
            </a>
        </StyledXCoverLink>
    );
};
